export {default as NotificationsNewTab} from './NotificationsNewTab';
export {default as NotificationsReadTab} from './NotificationsReadTab';



// WEBPACK FOOTER //
// ./src/components/Sliders/Notifications/index.js